<template>
  <div :v-show="listFilters.length > 0">
    <div class="listbox-filters">
      <span class="p-fluid fluid">
        <span
          aria-haspopup="listbox"
          aria-owns="pv_id_45_list"
          class="
            p-autocomplete
            p-component
            p-autocomplete-multiple
            p-inputwrapper-filled
          "
        >
          <ul class="p-autocomplete-multiple-container p-component p-inputtext">
            <li
              class="p-autocomplete-token"
              v-for="(filter, index) in listFilters"
              v-bind:key="index"
            >
              <span class="p-autocomplete-token-label">
                {{ filter.fieldsTranslated + filter.value }}
              </span>
              <span
                v-on:click="deleteFilter(filter.originalField)"
                class="p-autocomplete-token-icon pi pi-times-circle"
              >
              </span>
            </li>
            <li class="p-autocomplete-token p-autocomplete-token-danger">
              <span class="p-autocomplete-token-label">
                {{ $t("common.buttons.resetFilters") }}
              </span>
              <span
                v-on:click="resetFilters()"
                class="p-autocomplete-token-icon pi pi-times-circle"
              >
              </span>
            </li>
          </ul>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import DatesMixin from "@/utils/dates";
export default {
  name: "Filters",
  mixins: [DatesMixin],
  data() {
    return {};
  },
  props: ["computedFilters", "entity", "literalLists"],
  methods: {
    parseFilter(text) {
      var regex = new RegExp("(.*)~(.*)=(.*)");
      var match = regex.exec(text);
      var field = match[1];
      var value = match[3];
      return {
        field: field,
        value: value,
      };
    },
    isGuid(text) {
      if (text[0] === "{") {
        text = text.substring(1, text.length - 1);
      }
      var regexGuid =
        /^(\{){0,1}[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\}){0,1}$/gi;
      return regexGuid.test(text);
    },
    isEpochMillis(text) {
      var regexEpoch = /[0-9]{13}/;
      return regexEpoch.test(text);
    },
    textFilter(text) {
      let jsonFilter = this.parseFilter(text);
      let field = jsonFilter.field;
      let value = jsonFilter.value;
      var literalField = this.entity + ".filters." + field;
      var literalValue = value;

      if (this.literalLists != undefined) {
        for (var i = 0; i < this.literalLists.length; i++) {
          let lista = this.literalLists[i];
          if (lista != undefined && lista.length > 0) {
            for (var j = 0; j < lista.length; j++) {
              let literal = lista[j];
              if (literal["code"] === value) {
                literalValue = literal["name"];
              }
            }
          }
        }
      }

      if (this.isEpochMillis(value)) {
        var date = new Date(Number(value));
        literalValue = this.getFormattedDateLong(date);
      }

      return {
        originalField: field,
        fieldsTranslated:
          this.$i18n.t(literalField) +
          (literalValue != null && literalValue != "null" ? ": " : ""),
        value:
          literalValue != null && literalValue != "null" ? literalValue : "",
      };
    },
    deleteFilter(field) {
      this.$emit("filterToRemove", field);
    },
    resetFilters() {
      this.$emit("resetAllFilters");
    },
  },
  computed: {
    listFilters() {
      var filters = [];
      var filtersToExcludeFromFilters =
        this.fieldsToExcludeFromFilters != undefined &&
        this.fieldsToExcludeFromFilters != null
          ? this.fieldsToExcludeFromFilters
          : [];
      for (var i = 0; i < this.computedFilters.length; i++) {
        var computedFilter = this.computedFilters[i];
        if (computedFilter != undefined && computedFilter != null) {
          let filterText = this.textFilter(computedFilter);
          if (!filtersToExcludeFromFilters.includes(filterText.originalField)) {
            var index = filters.findIndex(
              (v) => v.originalField === filterText.originalField
            );
            if (index == -1) {
              filters.push(filterText);
            } else {
              filterText.value =
                filters[index].value + " - " + filterText.value;
              filters[index] = filterText;
            }
          }
        }
      }
      return filters;
    },
  },
};
</script>
<style lang="scss" scoped>
.listbox-filters {
  margin-bottom: 3px;
}
.p-autocomplete-token-danger {
  background: #e91224 !important;
}
</style>